import { Component, h } from 'preact';
import { HopplerModalizer } from '../../common/hoppler-modalizer.component';
import { InquiryDocumentType }  from '../../../../../constants/inquiries';

interface InqDocumentCreateSuccessModalProps {
  onClose: () => void;
  onProceedToLoiFileClick: () => void;
  showingForFirstSave: boolean;
  documentType: InquiryDocumentType
}

export class InqDocumentCreateSuccessModal extends Component<InqDocumentCreateSuccessModalProps> {
  getHeaderText() {
    const verb = this.props.showingForFirstSave ? 'Create' : 'Edit';
    const docTypeName = this.props.documentType === InquiryDocumentType.OFFER ? 'Offer' : 'Contract';

    return `${verb} ${docTypeName}`;
  }

  render(props: InqDocumentCreateSuccessModalProps) {
    const docTypeName = props.documentType === InquiryDocumentType.OFFER ? 'Offer' : 'Contract';
    return (
      <HopplerModalizer onClose={ () => null }>
        <div className="hi-doccreatedmodal">
          <div className="hi-doccreatedmodal__title-bar">
            <span className="hi-doccreatedmodal__title-label">
              { this.getHeaderText() }
            </span>

            <button className="btn btn-link hi-doccreatedmodal__title-close" onClick={ props.onClose }>
              <i className="fas fa-times" /> Close
            </button>
          </div>

          <div className="hi-doccreatedmodal__body">
            <div className="hi-doccreatedmodal__content">
              <h3 className="hi-doccreatedmodal__heading">Successful { docTypeName } Creation</h3>

              <p>You can find your newly created { docTypeName } under attachments.</p>
              <p>You can also download or share it from there.</p>

              <p className="mt-3">
                If not completed already, please request from the broker/owner
                documentation showing proof that the owner will be paying full
                commission (i.e.&nbsp;
                <a href="https://dzjqf1alh39sw.cloudfront.net/hoppler/kumita-files/COMMISSION_AGREEMENT_TEMPLATE.docx" target="_blank" rel="noopener">
                  Commission Agreement
                </a>)
              </p>

              <div className="hi-doccreatedmodal__buttons">
                <button className="btn btn-secondary" onClick={ props.onProceedToLoiFileClick }>Proceed to { docTypeName } file</button>
                <button className="btn btn-outline-dark" onClick={ props.onClose }>Back</button>
              </div>
            </div>
          </div>
        </div>
      </HopplerModalizer>
    )
  }
}
